var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 74,
    viewBox: "0 0 63 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2358 26.0857H62.25C60.5508 11.4179 47.264 0 31.125 0C14.986 0 1.69917 11.4179 0 26.0857H0.0139075C0.00469731 26.1965 0 26.3085 0 26.4217V70C0 72.2091 1.79086 74 4 74H58.25C60.4591 74 62.25 72.2091 62.25 70V65.3999V26.4248C62.25 26.3106 62.2452 26.1975 62.2358 26.0857Z",
    fill: "#DFE8F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCero);
export default __webpack_public_path__ + "static/media/cero.3fdf09636317876bbdb219343a40c1d7.svg";
export { ForwardRef as ReactComponent };